import React, {Component} from 'react'
import {Link} from 'react-router-dom'

class ModalTerm extends Component {

    clickTerm = () => {
        $('#modal-term-signup').modal('hide')

        this.props.history.push('/register')
    }

    render() {
        return (
            <div className="modal fade" id="modal-term-signup" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog" role="document">
                    <div className="modal-ruhu">
                        {/*<div className="mdr-title">
                            <div className="text">RUHU.SG TERMS AND CONDITIONS</div>
                            <a href="#" data-dismiss="modal" className="closeX">
                                <img src="/images/icon-close.png" alt="Ruhu"/>
                            </a>
                        </div>*/}
                        <div className="mdr-content">
                            {/*<div className="row" style={{fontSize: 15}}>
                                <p>I, representing myself and my company hereby accept and warrant that:</p>
                                <p>All information provided in this portal has been given consent by myself and my company</p>
                                <p>All information provided in this portal is true, complete and accurate with supporting documents</p>
                                <p>All clients engaged through RUHU Pte Ltd will be approached responsibly, deligently and ethically</p>
                                <p>RUHU Pte Ltd will not be hold responsible for any works and/or warranty of myself and my company services to my clients</p>
                                <p>RUHU Pte Ltd will not be hold responsible for any the information provided on myself and my company in this portal RUHU Pte Ltd reserves the right 
                                    to remove and/or correct my personal and/or company profile if the above conditions ar not met
                                </p>
                            </div>*/}
                            <div className="row" style={{fontSize: 15}}>
                                <p>Please indicate that you have read and agree to the Terms and Conditions and Privacy Policy</p>
                            </div>
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-md-3 col-lg-3 col-md-offset-9">
                                        <button onClick={this.clickTerm} type="button" className="bg-blue btn-blue btn-block btn-term">OK</button>
                                        {/*<button onClick={this.clickTerm} type="button" className="bg-blue btn-blue btn-block btn-term">I Agree the Terms</button>*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ModalTerm

